import { getCartCheckoutServiceUrl } from '@disw/ecommerce';
import { BASE_CDN_URL } from '../../disw-utils/src/constants/api_urls.js';
import { DEFAULT_LOCALE_CODE } from '../../disw-utils/src/constants/locales.js';
import logger from '../../disw-utils/src/logger.js';
import { DISW_LOGIN, EXTERNAL_CATEGORY, CONTENTFUL_DATA_API_URL, CONTENTFUL_DATA_API_URL_DEV, CONTENTFUL_DATA_API_URL_UAT, CONTENTFUL_DATA_API_URL_STAGE, CONTENTFUL_DATA_API_URL_XD, CONTENTFUL_DATA_API_URL_XD_DEV, CONTENTFUL_DATA_API_URL_XD_UAT, } from './constants.js';
export function renderTarget(category) {
    if (category === EXTERNAL_CATEGORY) {
        return {
            target: '_blank',
            rel: 'noopener noreferrer',
        };
    }
    return {};
}
// Cache the nav requests
const navCache = {};
// Make function async to ensure this function returns a promise
export async function fetchNavData(slug, locale = DEFAULT_LOCALE_CODE, env = 'prod') {
    const cacheKey = `${slug}_${locale}`;
    const nav = navCache[cacheKey];
    let globalNavApiUrl = '';
    if (env === 'qa' || env === 'dev') {
        globalNavApiUrl = CONTENTFUL_DATA_API_URL_DEV;
    }
    else if (env === 'uat') {
        globalNavApiUrl = CONTENTFUL_DATA_API_URL_UAT;
    }
    else {
        globalNavApiUrl = CONTENTFUL_DATA_API_URL;
    }
    // If a nav has been found in cache wether it is loading or loaded return it
    // This prevents duplicate requests
    if (nav) {
        return nav;
    }
    // Set the navCache for the slug_locale
    // Return the promise as the value of the cache
    navCache[cacheKey] = fetch(`${globalNavApiUrl}navigation/${locale}/${slug}.json`, {
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        return response.json();
    });
    return navCache[cacheKey];
}
// Duplicate of fetchNavData but specifically for the header
export async function fetchHeaderNavData(slug, locale = DEFAULT_LOCALE_CODE, env = 'prod') {
    const cacheKey = `${slug}_${locale}`;
    const nav = navCache[cacheKey];
    let globalNavApiUrl = '';
    if (env === 'qa' || env === 'dev') {
        globalNavApiUrl = CONTENTFUL_DATA_API_URL_XD_DEV;
    }
    else if (env === 'uat') {
        globalNavApiUrl = CONTENTFUL_DATA_API_URL_XD_UAT;
    }
    else {
        globalNavApiUrl = CONTENTFUL_DATA_API_URL_XD;
    }
    // If a nav has been found in cache wether it is loading or loaded return it
    // This prevents duplicate requests
    if (nav) {
        return nav;
    }
    // Set the navCache for the slug_locale
    // Return the promise as the value of the cache
    navCache[cacheKey] = fetch(`${globalNavApiUrl}header-navigation/${locale}/${slug}.json`, {
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        return response.json();
    });
    return navCache[cacheKey];
}
// Duplicate of fetchNavData but specifically for the footer
export async function fetchFooterNavData(slug, locale = DEFAULT_LOCALE_CODE, env = 'prod', fallbackSlug) {
    const cacheKey = `${slug}_${locale}`;
    const nav = navCache[cacheKey];
    let globalNavApiUrl = '';
    if (env === 'qa' || env === 'dev') {
        globalNavApiUrl = CONTENTFUL_DATA_API_URL_XD_DEV;
    }
    else if (env === 'uat') {
        globalNavApiUrl = CONTENTFUL_DATA_API_URL_XD_UAT;
    }
    else {
        globalNavApiUrl = CONTENTFUL_DATA_API_URL_XD;
    }
    // If a nav has been found in cache wether it is loading or loaded return it
    // This prevents duplicate requests
    if (nav) {
        return nav;
    }
    // Set the navCache for the slug_locale
    // Return the promise as the value of the cache
    navCache[cacheKey] = fetch(`${globalNavApiUrl}footer-navigation/${locale}/${slug}.json`, {
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (!response.ok) {
            // Retry with fallbackSlug
            return fetch(`${globalNavApiUrl}footer-navigation/${locale}/${fallbackSlug}.json`, {
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(fallbackResponse => {
                if (!fallbackResponse.ok) {
                    throw new Error(fallbackResponse.statusText);
                }
                return fallbackResponse.json();
            });
        }
        return response.json();
    });
    return navCache[cacheKey];
}
// const navCache: Map<string, any> = new Map();
// // Make function async to ensure this function returns a promise
// export async function fetchNavData(slug: string, locale = DEFAULT_LOCALE_CODE, env = 'prod') {
//   const cacheKey = `${slug}_${locale}`;
//   const nav = navCache.get(cacheKey);
//   let globalNavApiUrl = '';
//   if (env === 'qa' || env === 'dev') {
//     globalNavApiUrl = CONTENTFUL_DATA_API_URL_DEV;
//   } else if (env === 'uat') {
//     globalNavApiUrl = CONTENTFUL_DATA_API_URL_UAT;
//   } else {
//     globalNavApiUrl = CONTENTFUL_DATA_API_URL;
//   }
//   // If a nav has been found in cache wether it is loading or loaded return it
//   // This prevents duplicate requests
//   if (nav) {
//     return nav;
//   }
//   // Set the navCache for the slug_locale
//   // Return the promise as the value of the cache
//   navCache.set(cacheKey, fetch(`${globalNavApiUrl}navs/${slug}/${locale}`, {
//     mode: 'cors',
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   }).then(response => response.json()));
//   return navCache.get(cacheKey);
// }
/**
 * A helper function to build url with query parameters
 * @param {String} url A string value representing url
 * @param {Array} queryParameters An array of objects value representing each querystring key value. For example: [{key='id',value='1234'}]
 * @returns A String url or a url with query parameters
 */
export function buildUrl(url, queryParameters = []) {
    if (queryParameters.length === 0) {
        return url;
    }
    return url.indexOf('?') !== -1 ? `${url}&${queryParameters.map(e => `${e.key}=${e.value}`).join('&')}` : `${url}?${queryParameters.map(e => `${e.key}=${e.value}`).join('&')}`;
}
//Implemented the actual data retrieval mechanism from the CDN
export function fetchLocalNavData(slug, locale = DEFAULT_LOCALE_CODE, env = 'prod') {
    let navAPIURL = '';
    switch (env) {
        case 'prod':
            navAPIURL = CONTENTFUL_DATA_API_URL;
            break;
        case 'stage':
            navAPIURL = CONTENTFUL_DATA_API_URL_STAGE;
            break;
        case 'qa':
            navAPIURL = CONTENTFUL_DATA_API_URL_DEV;
            break;
        case 'uat':
            navAPIURL = CONTENTFUL_DATA_API_URL_UAT;
            break;
        default:
            navAPIURL = CONTENTFUL_DATA_API_URL_DEV;
    }
    if (env !== 'prod') {
        console.log('navApiUrl', navAPIURL, env);
    }
    return fetch(`${navAPIURL}local-navigation/${encodeURIComponent(locale)}/${encodeURIComponent(slug)}.json`, {
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (!response.ok) {
            logger.warn(`LocalNav: fetch failed for slug "${slug}" locale "${locale}" (HTTP ${response.status})`);
            return;
        }
        return response.json();
    });
}
/**
 * Check a value to see if it's true or false
 *
 * @param {value} value we want to determine the boolean of
 * @param {true|false} defaultValue if we can't determine the boolean quickly, just return the default
 * @returns {true|false}
 */
export function checkBool(value, defaultValue) {
    // If boolean, we're good to go
    if (typeof value === 'boolean') {
        return value;
    }
    // If string, check if it's 'true'
    if (typeof value === 'string') {
        return value.toLowerCase() === 'true';
    }
    // Otherwise, use the default
    return defaultValue;
}
/**
 * Format the currency for display based on the locale, currency and input price.
 *
 * @example <caption>Example Usage</caption>
 *  formatCurrency('en-US', 'USD', 3600) yields output = '$3,600'
 *
 * @param {string} locale for the currency (i.e., 'en-US')
 * @param {string} currency for the currency (i.e., 'USD')
 * @param {number} price being formatted
 * @returns price formatted with currency symbol
 */
export function formatCurrency(locale = 'en-US', currency = 'USD', price = 0) {
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol', // Prevent display of 2 digit currency code when locale doesn't match
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });
    return formatter.format(price);
}
export function getCurrencySymbol(locale = 'en-US', currency = 'USD') {
    return (0)
        .toLocaleString(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })
        .replace(/\d/g, '')
        .trim();
}
/**
 * Debounce function for scenarios where function should hold off executing until repeated user action
 * has concluded. When the function is called a timer counts down until either the timer runs out, or the function
 * is called again which resets the timer.
 *
 * @param {*} func function which will be executed if the timer runs out (repeated actions end).
 * @param {*} timeout time between repeated actions
 * @returns
 */
export function debounce(func, timeout = 600) {
    let timer;
    return function bounce(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}
/**
 * Prepend a query parameter into the url without reloading via the history.replaceState API. URL will be updated
 * without a refresh of the page. This function adds the parameter at the beginning of the URL's query string.
 *
 * @param {string} paramName of the query parameter being added to the URL.
 * @param {string} paramValue to be added as the value for the param name..
 */
export function prependQueryParameterToUrl(paramName, paramValue = '') {
    const params = new URLSearchParams(window.disw.NavigationService.getSearch());
    if (!params.has(paramName)) {
        // Create a new URLSearchParams object
        const newParams = new URLSearchParams();
        // Prepend the new parameter
        newParams.set(paramName, paramValue);
        // Append existing parameters to the newParams
        for (const [key, value] of params.entries()) {
            newParams.append(key, value);
        }
        // Update the URL
        window.history.pushState({ [paramName]: paramValue }, '', `?${newParams}`);
        // Make sure to update the login href when fullCart parameter is added
        if (document.getElementById(DISW_LOGIN)) {
            const { disw } = window;
            document.getElementById(DISW_LOGIN).href = disw.account.getLoginUrl();
        }
    }
}
/**
 * Remove a query parameter from the url without reloading via the history.replaceState API. URL will be updated
 * without a refresh of the page.
 *
 * @param {string} paramName of the query parameter being removed from the URL.
 */
export function removeQueryParameterFromUrl(paramName) {
    const params = new URLSearchParams(window.disw.NavigationService.getSearch());
    params.delete(paramName);
    window.history.pushState({ [paramName]: '' }, '', params.toString() === '' ? window.disw.NavigationService.getCurrentUrl().replace(window.disw.NavigationService.getSearch(), '') : `?${params}`);
    //Make sure to update the login href when fullcart prameter is removed
    if (document.getElementById(DISW_LOGIN)) {
        const { disw } = window;
        document.getElementById(DISW_LOGIN).href = disw.account.getLoginUrl();
    }
}
/**
 *  Truncates title or link to 55 characters if exceeds
 *
 * @param truncText
 * @param maxTextLength
 * @returns
 */
export function truncateTextFn(truncText, maxTextLength) {
    if (truncText.length >= maxTextLength) {
        return `${truncText.slice(0, maxTextLength - 1)}...`;
    }
    return truncText;
}
/**
 * Builds the URL for the Checkout Router Service process.
 * This function constructs the base URL and appends all necessary query parameters
 * required by the Checkout Service to complete its workflow.
 *
 * @param {boolean} marketingCheckoutEnabled - Indicates whether to route to the marketing checkout experience.
 * @param {string} cartId - The unique identifier of the current cart.
 *
 * @returns {string} The full URL to access the Checkout Service, including all required query parameters.
 */
export function getCheckoutServiceUrl(marketingCheckoutEnabled, cartId) {
    const checkoutServiceURL = new URL(getCartCheckoutServiceUrl());
    const account = window.disw.account.getAccount();
    checkoutServiceURL.search = new URLSearchParams({
        ...(account?.user?.jwt && { __tkn: account?.user?.jwt }),
        cartId,
        cartCountry: window.disw.country.getCountry().countrycode,
        returnToUrl: window.disw.NavigationService.getCurrentUrl(),
        timeStamp: Date.now(),
        marketingCheckoutExperience: marketingCheckoutEnabled ? 'enabled' : 'disabled',
    }).toString();
    return checkoutServiceURL.href;
}
/** @deprecated Use getCheckoutServiceUrl instead */
export const getDexCheckoutServiceUrl = getCheckoutServiceUrl;
/**
 * Determines the site checkout URL for the new checkout experience for the current site.
 * Works by determining the site domain and locale, and combining them to get the checkout URL for the given site.
 */
export function getOnSiteMarketingCheckoutURL() {
    const urlPieces = window.disw.NavigationService.getCurrentUrl().split('/');
    // We know that the protocol will be the first part of the url pieces (hopefully it's https ;)
    // The : will be included, because only the slashes are being removed
    const httpProtocol = urlPieces[0];
    // We know that the domain will be the 3rd url piece
    const siteDomain = urlPieces[2];
    // We know that the locale will be the 4th url piece
    const locale = urlPieces[3];
    // Now piece together the checkout URL
    return `${httpProtocol}//${siteDomain}/${locale}/checkout/`;
}
/**
 * Creates a listener to monitor changes in the browser's current URL via getCurrentUrl() and triggers a callback when it changes.
 *
 * @param {Function} callback - A function that receives the updated `href` value as a string whenever the URL changes.
 *
 * @returns {Function} A cleanup function that disconnects the `MutationObserver` to stop monitoring URL changes.
 *
 * @example
 * const unsubscribe = createHrefListener((newHref) => {
 *   console.log('URL changed to:', newHref);
 * });
 *
 * // Later, to stop listening:
 * unsubscribe();
 */
export function createHrefListener(callback) {
    // Initialize `currentHref` with the current URL.
    let currentHref = window.disw.NavigationService.getCurrentUrl();
    // Trigger callback immediately on first load
    callback(currentHref);
    // Create a MutationObserver to monitor changes in the DOM.
    const observer = new MutationObserver(() => {
        // Check if the URL has changed since the last observed state.
        if (window.disw.NavigationService.getCurrentUrl() !== currentHref) {
            // Update `currentHref` with the new URL.
            currentHref = window.disw.NavigationService.getCurrentUrl();
            // Trigger the callback with the updated URL.
            callback(currentHref);
        }
    });
    // Start observing changes in the document, focusing on subtree and child list changes.
    observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: false,
    });
    // Return a cleanup function to disconnect the observer when no longer needed.
    return () => {
        observer.disconnect();
    };
}
/**
 * Grabs the icon SVG from the CDN
 * @returns SVG containing icons in text
 */
export const getIcons = async () => {
    try {
        const icons = await fetch(`${BASE_CDN_URL}/icons/icons-vision.svg?v=2`);
        return icons.text();
    }
    catch (err) {
        console.error('Error while fetching icons -> ', err);
        return err;
    }
};
/**
 * Fetches localized tokens from the CDN for the given slug and locale
 * @param slug - The slug identifying the set of tokens to fetch
 * @param locale - The locale code for localization
 * @param env - The environment (dev, qa, prod)
 * @returns list of localized tokens
 */
export const getLocalizedTokens = async (slug, locale, env) => {
    try {
        const ENV = (env === 'dev' || env === 'qa') ? 'dev' : 'prod';
        const response = await fetch(`${BASE_CDN_URL}/translations/${ENV}/${slug}/translation-${locale}`);
        return response.json();
    }
    catch (err) {
        console.error('Error while fetching localized tokens -> ', err);
        return err;
    }
};
